import { store } from '@wajeez-web/stores/base';
import { handleDispatchResult } from '@wajeez-web/core/utils';

import { getLanguagesLookupsAsync } from './slices';

export const getLanguagesLookups = async (
  data: void,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getLanguagesLookupsAsync());

  return handleDispatchResult(res, onSuccess);
};
